import { render, staticRenderFns } from "./TypingStatusIndicator.vue?vue&type=template&id=18bf8917&"
import script from "./TypingStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./TypingStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports